import { ForwardedRef, InputHTMLAttributes, forwardRef } from 'react'
import { LinkIcon } from '@heroicons/react/24/outline'
import { cn } from 'shared/styles'

type Props = {
  label: string
  errorMessage?: string
  isRequired?: boolean
  isLink?: boolean
} & InputHTMLAttributes<HTMLInputElement>

export const FormInput = forwardRef(
  (
    { label, isRequired, errorMessage, isLink, ...props }: Props,
    ref: ForwardedRef<HTMLInputElement>,
  ) => (
    <div className='flex items-center justify-between'>
      <label
        className={cn(
          'grow text-base font-medium text-gray-900',
          isRequired && 'required',
        )}
        htmlFor={props.name}
      >
        {label}
      </label>
      <div className={cn('flex flex-col gap-y-1', isLink && 'relative')}>
        <input
          {...props}
          id={props.name}
          ref={ref}
          className={cn('base-input h-11 w-555 px-4 py-2.5', isLink && 'pr-11')}
        />
        {isLink && (
          <LinkIcon className='absolute top-3 right-4 size-5.5 text-slate-900' />
        )}
        {props['aria-invalid'] && errorMessage && (
          <p className='text-xs text-red-500'>{errorMessage}</p>
        )}
      </div>
    </div>
  ),
)
